import { Render } from '@/components/Helpers/ComponentRender/Render';
import PlayIcon from '@/components/icons/PlayIcon';
import { EventTracker } from '@/utils';
import { cn } from '@/utils/styles';
import { VideoList } from '@viome/viome-base/src/usecase/Education/EducationModel';

const EducationVideoCard = ({
  videoData,
  screen,
}: {
  videoData: VideoList;
  screen: string;
}) => {
  const handleYoutubeRedirection = (externalLink: string) => {
    window.open(externalLink, '_blank', 'noopener,noreferrer');
  };
  const themeMode = screen === 'health' ? 'dark' : 'light';
  const imageUrl = videoData?.image_url.replace(/'/g, "\\'");

  return (
    <div
      className="flex flex-col gap-2 justify-center cursor-pointer"
      onClick={() => {
        EventTracker.trackEvent(
          screen,
          `${screen}_jny_deeper_video_${videoData.video_id}`,
        );
        handleYoutubeRedirection(videoData.link);
      }}
    >
      <div
        className="bg-cover bg-center rounded-lg p-4 flex flex-col justify-between"
        style={{
          height: '12rem',
          backgroundImage: `url(${imageUrl})`,
        }}
      >
        <PlayIcon />
        <Render when={videoData?.subtitle}>
          <p className="typography-caption1 text-white">
            {videoData?.subtitle}
          </p>
        </Render>
      </div>
      <p className={cn(`typography-headline3 text-primary ${themeMode}`)}>
        {videoData?.video_title}
      </p>
    </div>
  );
};

export default EducationVideoCard;
